import { makeStyles } from "@material-ui/core/styles"

export const useStyles = makeStyles(theme => ({
  feesContainer: {
    display: "flex",
    flexDirection: "column"
  },
  title: {
    color: "#EA3558",
    fontSize: "22px",
    fontWeight: "bold",
    marginBottom: "20px"
  },
  paymentSection: {
    marginBottom: "25px",
    "&:last-child": {
      marginBottom: 0
    }
  },
  paymentType: {
    fontSize: "16px",
    fontWeight: "500",
    marginBottom: "12px",
    margin: 0
  },
  feeRow: {
    marginBottom: "8px",
    color: "#666",
    fontSize: "14px",
    "& span": {
      color: "#333",
      fontWeight: "500"
    },
    "&:last-child": {
      marginBottom: 0
    }
  },
  unavailableText: {
    color: "#666",
    fontStyle: "italic",
    fontSize: "14px"
  }
}))
